import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppComponent } from '@src/app/app.component';
import { JwtInterceptor } from '@src/app/_helpers/jwt.interceptor';
import { ErrorInterceptor } from '@src/app/_helpers/error.interceptor';
import { Ng7BootstrapBreadcrumbModule } from 'ng7-bootstrap-breadcrumb';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { TitleService } from '@src/app/_services/title.service';
import { AuthenticationService } from '@src/app/_services/authentication.service';
import { LayoutModule } from '@src/app/main-layout/layout.module';
import { ErrorModule } from '@src/app/main-layout/errors/error.module';
import { MessageService } from '@src/app/_services/message.service';
import { VersionCheckService } from '@src/app/_services/version-check.service';
import { DataService } from '@src/app/_services/data.service';
import { AutologoutService } from '@src/app/_services/autologout.service';
import { CustomStorageService } from '@src/app/_services/custom-storage.service';
import {
    MenuAllModule,
    SidebarModule,
    TreeViewAllModule,
} from '@syncfusion/ej2-angular-navigations';
import { MailerModule } from '@src/app/mailer/mailer.module';
import { EnvironmentService } from '@src/app/_services/environment.service';
import { INITIALIZER_PROVIDER } from '@src/app/_providers/initializer.provider';
import { ToastModule } from '@syncfusion/ej2-angular-notifications';
import { routes } from '@src/app/app.routes.const';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { CountdownComponent } from 'ngx-countdown';
import { DropDownButtonAllModule } from '@syncfusion/ej2-angular-splitbuttons';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        CountdownComponent,
        DialogModule,
        DropDownButtonAllModule,
        ErrorModule,
        HttpClientModule,
        LayoutModule,
        LoadingBarRouterModule,
        MailerModule,
        // ReportsModule, TODO
        RouterModule.forRoot(routes),
        MenuAllModule,
        Ng7BootstrapBreadcrumbModule,
        ReactiveFormsModule,
        SidebarModule,
        ToastModule,
        TreeViewAllModule,
    ],
    providers: [
        AuthenticationService,
        AutologoutService,
        CustomStorageService,
        DataService,
        EnvironmentService,
        INITIALIZER_PROVIDER,
        MessageService,
        TitleService,
        VersionCheckService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
